<script>
import VClamp from 'vue-clamp';

export default {
  name: 'CpSocialFeedLivestreamPost',
  directives: {
    margin: require('../../directives/margins').margin,
    marginBottom: require('../../directives/margins').marginBottom,
    marginTop: require('../../directives/margins').marginTop,
  },
  components: {
    CpBox: require('../../box').default,
    CpBoxContent: require('../../box-content').default,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    VClamp,
    SidebarMenuTvIcon: require('../icons/tv').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    CpSocialShareDialog: require('../../dialogs/social-share').default,
    CpButton: require('../../button').default,
    LikeIcon: require('../icons/like').default,
    LikeActionButton: require('../actions/like-action-button').default,
    CpLikesProfiles: require('../../likes/likes-profiles').default,
    CpDialog: require('../../dialog').default,
    CommentActionButton: require('../actions/comment-action-button').default,
    CpCommentsPost: require('../../comments/box-comments').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    CpShowInteractionsCount: require('../../components/ShowInteractionsCount').default,
  },
  props: {
    data: { type: Object, default: {} },
    playback: { type: String, default: '' },
    title: { type: String, default: 'Livestream' },
    type: { type: String },
    forShare: { type: Boolean, default: false }, //Is shared in explore
  },
  data() {
    return {
      showLikesModal: false,
      showComments: true,
      likes_count: this.data.likes_count,
      comments_count: this.data.comments_count,
      showAuthModal: false,
    };
  },
  methods: {
    profile() {
      if (this.type == 'livestream') {
        return '/profile/' + this.data.owner.slug;
      } else {
        return '/groups/' + this.data.group.id;
      }
    },
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleCountLikes(value) {
      if (value) {
        this.likes_count = this.likes_count + 1;
      } else {
        this.likes_count = this.likes_count - 1;
      }
    },
    setCount(type) {
      this.comments_count++;
    },
    setCommentsCount(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
    image() {
      return this.data.owner.profile_image;
    },
    name() {
      return this.data.owner.name;
    },
    // typePost() {
    //   return this.data.type == 'event' ? 'Event' : 'Livestream';
    // },
  },
  watch: {
    lobby(newResult) {
      this.comments_count = newResult.comments_count;
    },
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper">
    <div class="social-feed-post-profile-wrapper">
      <img :src="image" class="user-image" />

      <div class="">
        <span class="heading-4" style="margin: 0">
          <a :href="profile()">{{ name || 'Unknown user' }}</a>
        </span>
        <p class="content-1" style="margin: 0; padding-left: 2px">
          Livestream Video <span v-if="type == 'event'"> - Event from group {{ this.data.group.title }}</span>
        </p>
      </div>
    </div>
    <a :href="data.feed_permalink" class="headline black-color" v-margin-top="1" v-margin-bottom="1">
      <v-clamp :max-lines="1">{{ title }}</v-clamp>
    </a>
    <video v-if="playback" controls preload="metadata">
      <source :src="`${playback}`" type="video/mp4" />
    </video>
    <div v-else style="height: 400px; background-color: gainsboro; display: flex; flex-direction: column; align-items: center; justify-content: center">
      <p class="headline neutral6-color" v-margin="0">Uploading video...</p>
      <p class="body neutral6-color">It will be available in a few minutes!</p>
    </div>

    <div v-if="!forShare" style="margin-top: 10px !important">
      <CpShowInteractionsCount :type="data.video_type" :id="data.id" :likesCount="likes_count" :commentsCount="comments_count" :handleLikesModal="handleLikesModal" />
    </div>

    <cp-dialog v-if="showLikesModal">
      <cp-likes-profiles :count-likes="likes_count" :id="data.id" :type="data.video_type" @close="handleLikesModal"></cp-likes-profiles>
    </cp-dialog>

    <div v-if="!forShare" class="social-feed-post-actions">
      <div class="post-action-button like">
        <like-action-button :type="data.video_type" :id="data.id" :liked="data.liked" :onSuccess="handleCountLikes" />
      </div>
      <div class="post-action-button comment">
        <comment-action-button :type="data.video_type" :id="data.id" />
      </div>
      <div class="post-action-button share">
        <cp-social-share-dialog
          class="feed"
          :allow-share-feed="true"
          :share-category="type"
          :type="data.video_type"
          :post="data"
          share-button-class="button--noborder"
          :url="data.feed_permalink"
          :title="`Watch ${name} stream on CrowdBlue, the Social Network For Politics`"
          :description="`I found a stream of ${name} on CrowdBlue, the Social Network for Politics. Wanted to share with you!`"
          quote
          hashtags="crowdBlue,politics,political crowdfunding stream"
          twitter-user="crowdblue"
        ></cp-social-share-dialog>
      </div>
    </div>

    <cp-comments-post v-show="!forShare" :id="data.id" :type="data.video_type" :setCount="setCommentsCount"> </cp-comments-post>
  </div>
</template>
<style scoped>
video {
  max-width: 100%;
  max-height: 650px;
}
.description-wrapper,
.social-feed-post-link {
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
}
.button--darkgray-outline {
  transition: color 0.2s ease;
}
.liked {
  color: var(--highlight);
}
.user-image {
  border: 2px solid var(--primary2);
  border-radius: 50px;
  margin-right: 10px;
  width: 50px;
  height: 50px;
}
</style>
